import React from 'react';
import '../styles/MapPerformanceTable.css';

const MapPerformanceTable = ({ title, data, mode }) => {
  const modeNames = {
    HP: 'Hardpoint',
    SND: 'Search & Destroy',
    CTL: 'Control',
  };
  const modeTitle = modeNames[mode] || title;

  return (
    <div className="map-performance-container">
      <div className="mode-table-heading">
        <p>{modeTitle}</p>
        <h2 className="table-title">Map Performance</h2>
      </div>
      <div className="table-wrapper">
        <table className="performance-table">
          <thead>
            <tr>
              <th>Map</th>
              <th>WINS</th>
              <th>LOSSES</th>
              <th>WIN %</th>
              <th>PF</th>
              <th>PA</th>
              <th>[+/-]</th>
              <th>Attack Win %</th>
              <th>Defense Win %</th>
            </tr>
          </thead>
          <tbody>
            {data.length ? (
              data.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.Map}</td>
                  <td>{row.Wins}</td>
                  <td>{row.Losses}</td>
                  <td className={`win-rate ${getWinColor(row.WinRate)}`}>{row.WinRate}</td>
                  <td>{row.PF}</td>
                  <td>{row.PA}</td>
                  <td>{row.Diff}</td>
                  <td>{mode === 'HP' ? '-' : row.AttackWinRate}</td>
                  <td>{mode === 'HP' ? '-' : row.DefenseWinRate}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="performance-empty-row" colSpan="9">
                  No matches found for these filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const getWinColor = (pctString) => {
  const pct = parseFloat(pctString);
  if (pct >= 60) return 'win-high';
  if (pct >= 50) return 'win-mid';
  if (pct >= 40) return 'win-low';
  return 'win-bad';
};

export default MapPerformanceTable;
